import React from 'react';
import { Box, Typography } from '@mui/material';
import { QuestionCard } from '../QuestionCard';
import { StyledTextField } from '../StyledTextField';
import { colors } from '../../../../theme';

interface ContactInfoQuestionProps {
  email: string;
  firstName: string;
  onEmailChange: (value: string) => void;
  onFirstNameChange: (value: string) => void;
}

export const ContactInfoQuestion: React.FC<ContactInfoQuestionProps> = ({
  email,
  firstName,
  onEmailChange,
  onFirstNameChange
}) => {

  return (
    <QuestionCard>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              color: colors.deepNavy,
              marginBottom: '8px',
            }}
          >
            Your email:
          </Typography>
          <StyledTextField
            value={email}
            onChange={onEmailChange}
            placeholder="Your email"
            multiline={false}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              color: colors.deepNavy,
              marginBottom: '8px',
            }}
          >
            Your first name:
          </Typography>
          <StyledTextField
            value={firstName}
            onChange={onFirstNameChange}
            placeholder="Your first name"
            multiline={false}
          />
        </Box>
      </Box>
    </QuestionCard>
  );
};
